module.exports.Captcha = require('./src/reactjs-captcha');
module.exports.captchaSettings = require('./src/captcha-settings');


// WEBPACK FOOTER //
// ./src/reactjs-captcha/index.js